// One app-wide toast: `showToast(text)` from anywhere, `<ToastHost/>` mounted
// once in App.jsx (outside the router, so a toast survives the navigation that
// usually follows it — "Unlock sent" then back to the room).
//
// ⚠️ NO OK BUTTON (owner, 2026-10-20). A message that only informs goes here and
// closes itself; a tap dismisses it early. Keep a dialog only where the user must
// DECIDE something (confirm / cancel) or READ a long text (terms).

import React, { useEffect, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';

const listeners = new Set();

/** How long a toast stays: long enough to read, never a wait. */
export function toastDuration(text) {
  const n = String(text || '').length;
  return Math.min(7000, Math.max(2500, 1500 + n * 45));
}

/**
 * showToast('Unlock sent') or showToast('Wrong password', { severity: 'error' }).
 * severity: 'success' | 'info' | 'warning' | 'error' (default 'info').
 */
export function showToast(text, { severity = 'info' } = {}) {
  if (!text) return;
  const t = { id: Date.now() + Math.random(), text: String(text), severity };
  listeners.forEach((fn) => fn(t));
}

export default function ToastHost() {
  const [toast, setToast] = useState(null);
  useEffect(() => {
    const fn = (t) => setToast(t);
    listeners.add(fn);
    return () => listeners.delete(fn);
  }, []);
  const close = () => setToast(null);
  return (
    <Snackbar
      key={toast?.id}
      open={!!toast}
      autoHideDuration={toast ? toastDuration(toast.text) : null}
      onClose={(e, reason) => { if (reason !== 'clickaway') close(); }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ bottom: 'calc(env(safe-area-inset-bottom) + 72px) !important' }}
    >
      {toast ? (
        <Alert
          onClick={close}
          severity={toast.severity}
          variant="filled"
          sx={{ width: '100%', whiteSpace: 'pre-line', cursor: 'pointer' }}
        >
          {toast.text}
        </Alert>
      ) : <span />}
    </Snackbar>
  );
}
